
import { Component, Vue, Prop } from "vue-property-decorator"
import { UserFragmentFragment } from "@/gql"

@Component
export default class UserChip extends Vue {
  @Prop({ required: true })
  user!: UserFragmentFragment
}
